module.exports = __webpack_public_path__ + "media/images/premium/premium_image-ec7713aa08bdb512222177c381fff7b5.jpg";